angular.module('core')
  .factory('tooltips', [function () {
    return {
      "usage_extended_hours": "School hours are considered to be 8 AM to 4 PM on weekdays.",
      "initial_placement":"The <strong>Initial Placement</strong> setting affects where your student begins playing in DreamBox. After the student has completed one session, they&#8217;ll be considered &quot;already placed&quot;. In order to change this setting after the student&#8217;s first session, please contact Client Success at support@dreambox.com."
    };
  }]);
